import React from "react";
import GuideLayout from "../../components/layout/GuideLayout";
import Section from "../../components/layout/Section";
import Subheader from "../../components/layout/Subheader";
import {
  Typography,
  Link,
  Box,
} from "@mui/material";
import BulletList from "../../components/layout/BulletList";
import DefinitionTable from "../../components/layout/DefinitionTable";
import CodeHighlight from "../../components/layout/CodeHighlight";
import CodeBlock from "../../components/layout/CodeBlock";
import { useTheme } from "@mui/material/styles";

const termList = [
  {
    term: "gift box mystery capsule",
    definition: [
      "gbc",
      "gbcs",
      "cap",
      "caps",
    ]
  },
  {
    term: "black friday gift box mystery capsule",
    definition: [
      "bfgbc",
      "bfgbcs",
      "bf gbc",
      "bf gbcs",
      "bf gbc/s",
    ]
  },
  {
    term: "styling studio supplies",
    definition: [
      "sss"
    ]
  },
  {
    term: "deluxe styling studio supplies",
    definition: [
      "dsss",
      "d/sss",
      "deluxe sss"
    ]
  },
  {
    term: "styling studio prismatic brush",
    definition: [
      "prismatic brush",
      "prismatic brushes",
      "prisma brush",
      "prisma brushes",
      "prism brush",
      "prism brushes",
    ]
  },
  {
    term: "styling studio deluxe prismatic brush",
    definition: [
      "deluxe prismatic brush",
      "deluxe prismatic brushes",
      "deluxe prisma brush",
      "deluxe prisma brushes",
      "deluxe prism brush",
      "deluxe prism brushes",
    ]
  },
  {
    term: "styling studio restyle paint",
    definition: [
      "ssrp",
      "restyle",
      "restyles",
      "ss restyle",
      "ss restyles",
      "restyle paint",
      "restyle paints",
    ]
  },
  {
    term: "dyeworks hue brew potion",
    definition: [
      "dyepot",
      "dyepots",
      "dye potion",
      "dye potions",
      "dyeworks potion",
      "dyeworks potions",
      "dyework potion",
      "dyework potions",
    ]
  },
  {
    term: "faerie quest fortune cookie",
    definition: [
      "quest cookie",
      "quest cookies",
      "fqfc",
      "fqfcs",
      "fqc",
      "fqcs",
      "faerie quest cookie",
      "faerie quest cookies",
      "faerie cookies",
      "faerie cookie",
      "ffq cookie",
      "ffq cookies",
      "ffqs cookie",
      "ffqs cookies",
    ]
  },
  {
    term: "lab ray fortune cookie",
    definition: [
      "lab cookie",
      "lab cookies",
      "lab ray cookie",
      "lab ray cookies",
      "lrc",
      "lrcs",
    ]
  },
  {
    term: "petpet lab ray fortune cookie",
    definition: [
      "petpet cookie",
      "petpet cookies",
      "petpet lab cookie",
      "petpet lab cookies",
      "petpet lab ray cookie",
      "petpet lab ray cookies",
      "p2 cookie",
      "p2 cookies",
    ]
  },
  {
    term: "nc archives fortune cookie",
    definition: [
      "archives fortune cookie",
      "archives fortune cookies",
      "archives cookie",
      "archives cookies",
      "archive fortune cookie",
      "archive fortune cookies",
      "archive cookie",
      "archive cookies",
      "nc archive cookie",
      "nc archive cookies",
    ]
  },
  {
    term: "nc upcycle fortune cookie",
    definition: [
      "nc upcycle cookie",
      "nc upcycle cookies",
      "upcycle cookie",
      "upcycle cookies",
      "nc upcycle",
      "nc upcycles",
      "upcycle",
      "upcycles",
      "upcycle fortune cookie",
      "upcycle fortune cookies",
    ]
  },
  {
    term: "training fortune cookie",
    definition: [
      "training cookie",
      "training cookies",
    ]
  },

  {
    term: "deluxe training fortune cookie",
    definition: [
      "deluxe training cookie",
      "deluxetraining cookies",
    ]
  },
  {
    term: "plot points fortune cookie",
    definition: [
      "plot cookie",
      "plot cookies",
      "plot points cookie",
      "plot points cookies",
      "plot point cookie",
      "plot point cookies",
    ]
  },
  // { term: "a heroes welcome background", definition: "a heros welcome background" },
  // { term: "cherry blossom tea pot handheld", definition: "cherry blossom teapot handheld" },
  // { term: "psimouse tea pot handheld", definition: "psimouse teapot handheld" },
  // { term: "dyeworks baby blue: baby valentine jumper", definition: "dyeworks baby blue: baby valentine jumper and shirt" },
  // { term: "dyeworks baby pink: baby valentine jumper", definition: "dyeworks baby pink: baby valentine jumper and shirt" },
  // { term: "dyeworks baby purple: baby valentine jumper", definition: "dyeworks baby purple: baby valentine jumper and shirt" },
  // { term: "dyeworks black: games master challenge 2010 lulu shirt", definition: "dyeworks black: 2010 games master challenge nc challenge lulu shirt" },
  // { term: "dyeworks orange: games master challenge 2010 lulu shirt", definition: "dyeworks orange: 2010 games master challenge nc challenge lulu shirt" },
  // { term: "dyeworks purple: games master challenge 2010 lulu shirt", definition: "dyeworks purple: 2010 games master challenge nc challenge lulu shirt" },
  // { term: "dyeworks black: field of flowers", definition: "dyeworks black: field of flowers foreground" },
  // { term: "dyeworks blue: field of flowers", definition: "dyeworks blue: field of flowers foreground" },
  // { term: "dyeworks yellow: field of flowers", definition: "dyeworks yellow: field of flowers foreground" },
  // { term: "dyeworks fuschia: jars of magic foreground", definition: "dyeworks fuchsia: jars of magic foreground" },
  // { term: "dyeworks orange & pink: winter lights effects", definition: "dyeworks orange & pink: winter lights effect" },
  // { term: "dyeworks red & green: winter lights effects", definition: "dyeworks red & green: winter lights effect" },
  // { term: "dyeworks yellow & magenta: winter lights effects", definition: "dyeworks yellow & magenta: winter lights effect" },
  // { term: "dyeworks red radioactive mutant markings", definition: "dyeworks red: radioactive mutant markings" },
  // { term: "eternal hearts backround", definition: "eternal hearts background" },
  // { term: "holiday secret meepit stach plan 1-pack", definition: "holiday secret meepit stache plan 1-pack" },
  // { term: "purple flower embroidiery dress", definition: "purple flower embroidery dress" },
  // { term: "retired contacts ii mystery capsule 202410-bundle", definition: "retired contacts ii mystery capsule 2024 10-bundle" },
  // { term: "snorkel petpet companion and pitchfork handheld", definition: "snorkle petpet companion and pitchfork handheld" },
  // { term: "strapping pharoah fit", definition: "strapping pharaoh fit" },
  // { term: "vip gold embellishedtuxedo", definition: "vip gold embellished tuxedo" },
  // { term: "ye old fishing vortex new years background", definition: "ye olde fishing vortex new years background" },
  // { term: "dyeworks magenta: lovely berry blush", definition: "dyeworks magenta: lovely berry blush makeup" },
  // { term: "dyeworks soft pink: lovely berry blush", definition: "dyeworks soft pink: lovely berry blush makeup" },
  // { term: "dyeworks peach: lovely berry blush", definition: "dyeworks peach: lovely berry blush makeup" },

  { term: "body be-gone!", definition: ["body be-gone", "body be gone"] },
  { term: "antenna & horns be-gone!", definition: ["antenna & horns be-gone", "antenna and horns be gone"] },
  { term: "drippings be-gone!", definition: ["drippings be-gone", "drippings be gone"] },
  { term: "eyes be-gone!", definition: ["eyes be-gone", "eyes be gone"] },
  { term: "feet be-gone!", definition: ["feet be-gone", "feet be gone"] },
  { term: "glow effects be-gone!", definition: ["glow effects be-gone", "glow effects be gone"] },
  { term: "hind be-gone!", definition: ["hind be-gone", "hind be gone"] },
  { term: "hair be-gone!", definition: ["hair be-gone", "hair be gone"] },
  { term: "mouth be-gone!", definition: ["mouth be-gone", "mouth be gone"] },
  { term: "ruff be-gone!", definition: ["ruff be-gone", "ruff be gone"] },
  { term: "wings be-gone!", definition: ["wings be-gone", "wings be gone"] },
];

const commandsList = [
  (<><CodeHighlight text="/register" />- brings up the register modal for registering a user to submit reports</>),
  (<><CodeHighlight text="/report" />- brings up the report modal for a user to report their trade</>),
  (<><CodeHighlight text="/search (item name)" />- displays full trade data (up to 15 trades) for the item searched</>),
  (<><CodeHighlight text="/itemStats (item name)" />- displays trade data summary for the item searched</>),
  (<><CodeHighlight text="/mystats" />- displays your trading statistics (message is private and viewable only to you)</>),
];

const validInputList = [
  (<><CodeHighlight text="gbc (1) + Succulent Bouquet (1)" size="medium" /></>),
  (<><CodeHighlight text="5x sss (3)" size="medium" /></>),
  (<><CodeHighlight text="Dreamy Summer Beach Background (2-3)" size="medium" /></>),
];

const invalidInputList = [
  (<><CodeHighlight text="Pink Baby Body Paint (2-3) + gbc" size="medium" />→ no value on gbc</>),
  (<><CodeHighlight text="Bronze Clockwork Wings (0.5)" size="medium" /> → we do not take half values</>),
  (<><CodeHighlight text="Bouncing Tennis Ball (0-1)" size="medium" />→ values must be 1 or greater</>),
  (<><CodeHighlight text="5 bfgbcs (1)" size="medium" />→ quantities must be denoted with an x after</>),
  (<><CodeHighlight text="800nc custom (4)" size="medium" />→ must list each item with values; "custom" is not a valid item name</>),
];

const oddItems = [
  (<><CodeHighlight text="Ultimate Altador Cup Gear Pack (2019)" size="medium" /> → search & report as <CodeHighlight text="Ultimate Altador Cup Gear Pack 2019" size="medium" /></>),
  (<><CodeHighlight text="Ultimate Altador Cup Gear Pack (2022)" size="medium" />→ search & report as<CodeHighlight text="Ultimate Altador Cup Gear Pack 2022" size="medium" /></>),
];

const sections = [
  { id: "intro", title: "Lebronbot" },
  { id: "getting-started", title: "Getting Started" },
  {
    id: "report",
    title: "Reporting Trades",
    children: [
      { id: "format", title: "Formatting Rules" },
      { id: "odd-items", title: "Odd Items" },
      { id: "example", title: "Examples" },
    ]
  },
  {
    id: "search", title: "Search Trade Data",
    children: [
      { id: "item-stats", title: "Item Stats" },
      { id: "search-onsite", title: "Searching on Stylisher" },
    ]
  },
  { id: "stats", title: "Your Reporting Statistics" },
  { id: "shortcut", title: "Acronyms and Shortcuts" },
];

const LebronBotGuide = () => {
  const theme = useTheme();

  return (
    <GuideLayout sections={sections}>
      <Section id="intro" title="How to Use LebronBot">
        <Typography
          variant="caption"
          color="secondary"
          sx={{ mt: -1, mb: 2, display: "block" }}
        >
          Last updated: April 2026
        </Typography>
        <Typography paragraph>
          This guide will go over Lebronbot setup and the commands available to use. Lebron is our NC value guide, and lebronbot is a helpful discordbot that users can interact with to report their trades and get the latest trade data. The values on our value guide is based off of community values, which comes entirely from user reported data. We encourage everyone to report their trades - the more data we have, the more accurate our guide will be!
        </Typography>
      </Section>

      <Section id="getting-started" title="Getting Started">
        <Typography paragraph>
          To get access to Lebronbot, join our <Link sx={{ color: theme.palette.secondary.main }} href="https://discord.gg/HtpWdxZV4U">discord server</Link>. You will need to create discord account or log into an existing one to join the server. Once you join the server, please read and review our server rules. When you agree to the rules, you'll be able to access our <b>#search-and-report</b> channel, where you can start using lebronbot commands!
        </Typography>

        <Box sx={{ textAlign: "center", m: 2, mb: 3 }}>
          <img src={require('../../assets/lebron/discordinvite.png')} alt="discord invite" style={{ width: '420px', maxWidth: "90%", borderRadius: 5 }} />
        </Box>

        <Subheader title="Slash Commands" />
        Here are the the slash commands we have available.
        <BulletList items={commandsList} />
        To use a slash command, simply type
        <CodeHighlight text="/commandname" />
        into chat. As you type, you can select it from the suggestions or type the full command and a space to activate it. Let's use register as an example. Here is me typing
        <CodeHighlight text="/register" />
        and the suggestion that appears.

        <Box sx={{ textAlign: "center", m: 2, mb: 3 }}>
          <img src={require('../../assets/lebron/registercommand.png')} alt="register command suggestion example" style={{ width: '420px', maxWidth: "95%", borderRadius: 5 }} />
        </Box>

        When I select it, the command is now bold because it recognizes it as a valid command, and I can hit enter to activate it.
        <Box sx={{ textAlign: "center", m: 2, mb: 3 }}>
          <img src={require('../../assets/lebron/registercommandactivated.png')} alt="register command suggestion example" style={{ width: '420px', maxWidth: "95%", borderRadius: 5 }} />
        </Box>
        <Typography paragraph>
          Registering is not required for searching items and is only required for reporting. When you try to report for the first time, it will prompt you to the registration modal if you have not registered before. The register command prompts the same modal - we keep this command around as an option to register manually just in case the report command does not prompt it.
        </Typography>

        <Typography paragraph>
          We require users to register their neopets username before reporting in case we need to contact for clarifying information (ex: seemingly duplicate trades, trade amendments, etc). When searching for reports, usernames will never be shown so users will never see who reported a trade. The only people who can see usernames are team members with admin access.
        </Typography>
      </Section>

      <Section id="report" title="Reporting Trades">
        <Typography paragraph>
          To report your trade, type <CodeHighlight text="/report" /> into the message box. The command from Lebron should populate in the menu above. Click on it, or press "tab" on your keyboard (if it is the first in the list). Click send, and a modal should open on your screen like this.
          <Box sx={{ textAlign: "center", m: 2, mb: 3 }}>
            <img src={require('../../assets/lebron/reportmodal.png')} alt="report modal" style={{ width: '420px', maxWidth: "90%", borderRadius: 5 }} />
          </Box>

          If you are reporting for the first time, it will show you a registration modal instead. Once you register, you can try the report command again to see the above modal.
        </Typography>
        <Typography paragraph>
          From there, you can fill out your trade details.

          It is highly recommended to copy and paste the item names from JN or DTI. Make sure the inputted date is accurate and add any notes you wish (Remember, this can be seen by others!). If all is correct, click submit. If successful, your report will be accepted and you will get a reponse indicating so. If your report was rejected, it is likely that there was an error in your formatting. If you are unfamiliar with the formatting rules, please refer to the next section here or the report section in the faq on the discord server.
        </Typography>

        <Subheader id="format" title="Formatting Rules" />
        <Typography paragraph>
          Trade reports must strictly follow these formatting rules in order to be submitted to the database. We require exact item names and formatting in order to keep our project sustainable for long time use as the alternative is to have people manually review each trade, which we feel is unnecessary and leads to quick burnout. If your trade does not follow the required format, your trade will be rejected, but feel free to review the formatting rules and try again!
        </Typography>

        Whenever you report a trade, it must be in this format:
        <CodeBlock text="Full Item Name (value)" />

        If you have multiple items to add, they must be seperated by a + sign like so:

        <CodeBlock text="Full Item Name (value) + Another Full Item Name (value)" />

        <Typography paragraph>
          <b>Values must always be inside parentheses.</b> We allow ranges indicated by a dash, but all numbers must be a whole number 1 or greater. For example,
          <CodeHighlight text="(1-2)" />
          is fine, but
          <CodeHighlight text="(0-1)" />
          or
          <CodeHighlight text="(0.5)" />

          are not. Please do NOT add any additional symbols! We are looking for your personal values so we can have the most accurate data. Vague values like (???) and (2+) are not very helpful; please specify a complete value or range. If you are unsure, feel free to put your thoughts in the notes section!
        </Typography>

        <Typography paragraph>
          <b>Quantities are optional</b> - anything without a quantity indicated will have a default quantity of 1. However, if you would like to indicate a quantity, it must be a positive whole number followed by an 'x'.
        </Typography>
        <CodeBlock text="#x Full Item Name (personal value per 1 item)" />

        <Typography paragraph>
          <b>Values should be per item.</b> We understand it may get time to get used to, but if you indicate quantity, please note your personal value as you would for just 1 of those items. For example, if you value a Succulent Bouquet at 1 cap but traded 5 of them, your input would be
        </Typography>
        <CodeBlock text="5x Succulent Bouquet (1)" />

        <Subheader id="odd-items" title="Exceptions: Odd Items" />
        There are a few odd items whose full names would disrupt the consistency of our system, so we have different versions. Please keep note of these and report as the alternative as listed:

        <BulletList items={oddItems} />
        <Typography paragraph>
          For items that have identical names, please indicate which one you traded in the notes.
        </Typography>

        <Typography paragraph>
          For your convenience, we've also added support for a few common item acronyms (gbc, bfgbc, sss, dsss, fqc, upcycles) so you do not have to copy and paste those full item names. For a comprehensive list of these, please refer to the large <b>Acronyms and Shortcuts</b> section further in this guide. Note: The rest of the formatting rules still apply - you must still indicate a value for these items!
        </Typography>


        <Subheader id="example" title="Examples" />
        All of these are examples of <b>valid</b> input:
        <BulletList items={validInputList} />
        <Typography paragraph>
          These inputs are invalid and would be rejected.
        </Typography>
        <BulletList items={invalidInputList} />
      </Section>

      <Section id="search" title="Search Trade Data">
        <Typography paragraph>
          To search trade reports for an item, type <CodeHighlight text="/search" /> into the message box. The command from Lebron should populate in the menu above. Click on it, or press "tab" on your keyboard (if it is the first in the list). Now you can type in the <b>exact name</b> of the item you are looking for. It is recommended to copy and paste the item name from JN or DTI. Once you have your item name put in, hit send and Lebron will pull up the reports and value for said item.
          <Box sx={{ textAlign: "center", m: 2, mb: 3 }}>
            <img src={require('../../assets/lebron/searchexample.png')} alt="search example" style={{ width: '420px', maxWidth: "95%", borderRadius: 5 }} />
          </Box>

          If there is trade data, you should get results like this. Feel free to browse through the pages to review data - the command pulls up to the latest 15 reports.
          <Box sx={{ textAlign: "center", m: 2, mb: 3 }}>
            <img src={require('../../assets/lebron/searchresult.png')} alt="search example" style={{ width: '420px', maxWidth: "95%", borderRadius: 5 }} />
          </Box>

          If an item is not found but has similar items, you will get item name suggestions to try again. We put this in place for any easy typos or for instances when you're trying to remember an item but perhaps missed a word. August 2025 Update: Now we have easy click buttons for suggestions to research for you!
          <Box sx={{ textAlign: "center", m: 2, mb: 3 }}>
            <img src={require('../../assets/lebron/search_suggestion.png')} alt="search example" style={{ width: '600px', maxWidth: "95%", borderRadius: 5 }} />
          </Box>
          <Typography paragraph>
            If an item is not found and has no similar names, you'll get the "(item name) does not exist in the database" result with no suggestions. In that case, please double check your input because it is not an item in our database. If you are sure it is an item, please inform a team member in our #help channel or submit a ticket!
          </Typography>

          <Typography paragraph>
            Note: If it is a newly released item, please give our team some time to get that into our database. We aim to update asap, but we may not always be online right at the 10am releases to record new items. If it's been over 24hrs or if you notice TNT has changed an item name, ping us and let us know!
          </Typography>

        </Typography>

        <Subheader id="item-stats" title="Item Stats" />
        <Typography paragraph>
          To get a trade summary and item stats for an item, type <CodeHighlight text="/itemstats" /> into the message box. Similar to search, you can select the command and type in the <b>exact name</b> of the item you are looking for. ItemStats will give you the recent trade data and relevant notes, much like a trade data summary that you can easily copy and paste.
          <Box sx={{ textAlign: "center", m: 2, mb: 3 }}>
            <img src={require('../../assets/lebron/itemstats.png')} alt="example of itemstats command" style={{ width: '600px', maxWidth: "95%", borderRadius: 5 }} />
          </Box>
        </Typography>
        <Typography paragraph>
          As shown above, the most recent 5 reports will be shown as well as whether the item was sent or received in the trade report. Please note that our calculated values may take in other trade data into account and may not be solely based on the summary, but it can be useful to gauge reports at a glance.
        </Typography>

        <Subheader id="search-onsite" title="Searching on Stylisher" />
        <Typography paragraph>
          Since you're on this site anyways, this is a good opportunity to mention that you can also search for trade reports right here on this site! Use the search bar at the top of the page, and it will also pull up trade data. Discord has certain message limits so the bot will only pull up to the latest 15 trades and may sometimes (on very rare occasions!) truncate longer notes from older/inherited data, but our site does not have the same limits. We display up to 30 trade reports in full when you search on this site and we have a one click copy to clipboard feature (for both item stats and per trade!) in case you ever need to reference one. Feel free to use whatever is most convenient for you!
        </Typography>
      </Section>

      <Section id="stats" title="Your Reporting Statistics">
        Type <CodeHighlight text="/mystats" /> to pull up some info on your contributions! We've set the response to be private, so no worries about trying it out - it will only be visible to you! These stats do nothing and they do not affect any values. We just made this command to make trading and reporting a lil bit more fun. Thanks for reporting your trades! :)
      </Section>

      <Section id="shortcut" title="Acronyms and Shortcuts">
        For full reference, here are all the additional terms we accept where you do not have to use the full name. Most of these are common acronyms (gbc, sss, dsss, etc) but we've added some of the more uncommon ones too. These are based off what we saw in old reports as we were migrating data as well as browsing on boards. Towards the end, there's also items that have potentially incorrect/updated/annoying names on site, and we'll try to keep track of them and update in case TNT changes those names as well. Overall, this just exists for convenience - if you prefer to use the full name still, feel free to do so!
        <DefinitionTable termList={termList} colHeader1="Full Item Name" colHeader2="Supported Term" />
      </Section>

    </GuideLayout>
  );
};

export default LebronBotGuide;
